import React from "react";

import { PageBuilderCardSliderFragment } from "types/graphql-types";
import { Slider, SliderSlide } from "@silversea-ssc/ui-components-react";
import PageBuilderSectionTitle from "../PageBuilderSectionTitle";
import { graphql } from "gatsby";

import { BackgroundColor } from "types/componentBackground";
import { isPresent } from "src/utils/checks";
import { cardColorForBackground } from "../pageBuilderRenderHelper";
import PageBuilderCardSliderItem from "./PageBuilderCardSliderItem";
import PageBuilderPackageCardItem from "./PageBuilderPackageCardItem";

export type PageBuilderCardSliderProps = PageBuilderCardSliderFragment & {
  backgroundColor: BackgroundColor;
};

const PageBuilderCardSlider: React.FC<
  React.PropsWithChildren<PageBuilderCardSliderProps>
> = ({ heading, backgroundColor, items = [] }) => {
  const cardBackgroundColor = cardColorForBackground(backgroundColor);
  const filteredItems = items.filter(isPresent);

  return (
    <React.Fragment>
      <PageBuilderSectionTitle {...heading} />
      <Slider variantColor={cardBackgroundColor}>
        {filteredItems.map((item) => {
          if (item.__typename === "SanityPackageCard") {
            return (
              <SliderSlide key={item?._key}>
                <PageBuilderPackageCardItem
                  {...item}
                />
              </SliderSlide>
            );
          }

          return (
            <SliderSlide key={item?._key}>
              <PageBuilderCardSliderItem
                cardBackgroundColor={cardBackgroundColor}
                {...item}
              />
            </SliderSlide>
          );
        })}
      </Slider>
    </React.Fragment>
  );
};

export default PageBuilderCardSlider;

export const fragments = graphql`
  fragment PageBuilderCardSliderItem on SanitySliderCard {
    _key
    image {
      ...ImageWithAlt
    }

    title {
      localized
    }

    description {
      localized
    }

    ctaButtons {
      ...ButtonCTA
    }
  }

  fragment PageBuilderPackageCardItem on SanityPackageCard {
    _key

    title {
      localized
    }

    subtitle {
      localized
    }

    content {
      localized
    }

    footer {
      localized
    }

    ctaButtons {
      ...ButtonCTA
    }
  }

  fragment PageBuilderCardSlider on SanityCardSlider {
    _key
    sectionLayoutConfig {
      ...SectionLayoutConfig
    }
    heading {
      ...SectionTitle
      ...SectionTitleCTAs
    }
    items {
      ... on SanitySliderCard {
        __typename
        ...PageBuilderCardSliderItem
      }

      ... on SanityPackageCard {
        __typename
        ...PageBuilderPackageCardItem
      }

      ...PageBuilderCardSliderItem
    }
  }
`;
